import { createStructuredSelector } from 'reselect';

export const fetchGAWState = (state) => state.grantAgreements;

export const fetchMessageState = (state) => state.messaging;

export const selectAccountId = (state) => {
  const { data } = fetchGAWState(state).accountData;
  return data ? data.accountId : null;
};

export const selectGrantAgreementFlag = (state) => {
  const { additionalAccountDetails } = fetchMessageState(state).messages;
  return additionalAccountDetails
    ? additionalAccountDetails.grantAgreementFlag
    : false;
};

export const landingPageDerivedStates = createStructuredSelector({
  accId: selectAccountId,
  grantAgreementFlag: selectGrantAgreementFlag,
});
